<template>
  <div class="message-container" :data-num-messages="filteredMessages.length">
    <Message
      v-for="message in filteredMessages"
      :key="message.id"
      :severity="message.severity"
      :icon="message.icon"
      :closable="message.closable"
      :class="messageClass"
    >
      <template v-if="message.iconSlot" #icon>
        <component :is="message.iconSlot" />
      </template>

      <template v-if="message.textSlot" #default>
        <component :is="message.textSlot" />
      </template>
      <template v-else-if="message.onClick" #default>
        <RygenButton
          mode="tertiary"
          :label="message.text"
          @click="message.onClick"
        />
      </template>
      <template v-else #default>
        {{ message.text }}
      </template>
    </Message>
  </div>
</template>

<script lang="ts" setup>
import type { ClassValue, PropType } from 'vue';
import { computed, toRefs } from 'vue';

import { MessageSpecification } from '@/model';
import { isMessageVisible } from '@/stores/Message';

import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';
import Message from 'primevue/message';

const props = defineProps({
  messages: {
    type: Array as PropType<MessageSpecification[]>,
    default: () => [],
  },
  messageClass: {
    type: [String, Object] as PropType<ClassValue>,
    default: () => '',
  },
});
const { messages, messageClass } = toRefs(props);

const filteredMessages = computed(() =>
  messages.value.filter(isMessageVisible),
);
</script>

<style>
.message-container {
  display: flex;
  flex-direction: column;
  gap: var(--gap-1);

  &[data-num-messages='0'] {
    display: none;
  }

  .p-message {
    margin: 0;
  }
}
</style>
